(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    }
    else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        // CommonJS
        module.exports = factory();
    }
    else {
        // Browser global
        root.analytics = factory();
    }
})(this, function () {
    'use strict';
    var _initialized = false;
    var _currentPage = null;
    var _prodUrlToken = '.apps.enelx.com';
    var _prodUrlTokenLegacy = '.eis.enernoc.com';
    var _environments = {
        development: 'b96266152ae34583b5782eea4b1632dc',
        production: 'fe105d8f7bfab0ed9b427a4e4ad89112'
    };
    var _defaultProps = {};
    /**
     * Initialize the analytics library so user events and browser information can be tracked
     *
     * @param {string} userId - (required) platform user id
     * @param {string} application - (required) name of current application
     * @param {boolean} isMobilePlatform - (optional) if inside nativescript webview set to 'true'.  Defaults to 'false'
     * @param {string} environmentKey - (optional) override mixpanel environment token
     *
    **/
    function init(userId, application, isMobilePlatform, environmentKey) {
        var appType = 'Web App';
        var mixpanelToken = _environments.development;
        if (!userId) {
            throw new Error('noc-analytics: userId required');
        }
        if (!application) {
            throw new Error('noc-analytics: application name required');
        }
        if (!environmentKey && (window.location.hostname.indexOf(_prodUrlToken) > -1 || window.location.hostname.indexOf(_prodUrlTokenLegacy) > -1)) {
            mixpanelToken = _environments.production;
        }
        else if (environmentKey) {
            mixpanelToken = environmentKey;
        }
        _initialized = true;
        if (isMobilePlatform) {
            appType = 'Mobile App';
        }
        window.mixpanel.init(mixpanelToken);
        registerProperties({
            'Application': application,
            'Application Type': appType
        });
        window.mixpanel.identify(userId);
    }
    /**
     * Push an event into mixpanel
     *
     * @param {string} eventName - (required) name of event to track
     * @param {Object} properties - (required) additional event data/attributes
     * @param {string} eventPage - (optional) override page name
     */
    function pushEvent(eventName, properties, eventPage) {
        if (!_initialized) {
            throw new Error('Failed to send analytics event!  Make sure to call init() first');
        }
        var props = {};
        Object.keys(_defaultProps).forEach(function (k) {
            props[k] = _defaultProps[k];
        });
        if (properties) {
            Object.keys(properties).forEach(function (k) {
                props[k] = properties[k];
            });
        }
        if (_currentPage || eventPage) {
            props['Page'] = _currentPage || eventPage;
        }
        else {
            console.warn('WARNING: noc-analytics page not set!  Use setPage() to set current application page');
        }
        try {
            window.mixpanel.track(eventName, props);
        }
        catch (error) {
            if (error.message === 'Maximum call stack size exceeded') {
                console.error("[" + error.message + "] this is likely caused by circular structure in the props:", props);
            }
            else {
                console.error(error);
            }
        }
    }
    /**
     * Register current page of application for all future events within the current application instance
     *
     * @param {string} pageName - name of current page in application
     */
    function setPage(pageName) {
        _currentPage = pageName;
    }
    /**
     * Register a set of properties to be included with all future events in this application instance
     * Duplicates will override last in
     *
     * @param {Object} properties - map of properties to register
     */
    function registerProperties(properties) {
        Object.keys(properties).forEach(function (k) {
            _defaultProps[k] = properties[k];
        });
    }
    /**
     * Get raw mixpanel API object
     *
     * @returns {Object} - Mixpanel API
     */
    function getMixpanel() {
        return window.mixpanel;
    }
    return {
        init: init,
        setPage: setPage,
        pushEvent: pushEvent,
        registerProperties: registerProperties,
        getMixpanel: getMixpanel
    };
});
// installs mixpanel beacon on page
(function (e, a) {
    if (!a.__SV) {
        var b = window;
        try {
            var c, l, i, j = b.location, g = j.hash;
            c = function (a, b) { return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null; };
            g && c(g, "state") && (i = JSON.parse(decodeURIComponent(c(g, "state"))), "mpeditor" === i.action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)));
        }
        catch (m) { }
        var k, h;
        window.mixpanel = a;
        a._i = [];
        a.init = function (b, c, f) { function e(b, a) { var c = a.split("."); 2 == c.length && (b = b[c[0]], a = c[1]); b[a] = function () { b.push([a].concat(Array.prototype.slice.call(arguments, 0))); }; } var d = a; "undefined" !== typeof f ? d = a[f] = [] : f = "mixpanel"; d.people = d.people || []; d.toString = function (b) { var a = "mixpanel"; "mixpanel" !== f && (a += "." + f); b || (a += " (stub)"); return a; }; d.people.toString = function () { return d.toString(1) + ".people (stub)"; }; k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" "); for (h = 0; h < k.length; h++)
            e(d, k[h]); a._i.push([b, c, f]); };
        a.__SV = 1.2;
        b = e.createElement("script");
        b.type = "text/javascript";
        b.async = !0;
        b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
        c = e.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(b, c);
    }
})(document, window.mixpanel || []);
